import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import Coin from "../../assets/stcoin.png";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import { IconButton, Typography, useMediaQuery, useTheme } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import Image from "next/image";
import "./index.css";

interface ProductDetailsProps {
  open: any;
  close: any;
  handleClickButton: any;
  handleValueIncrease: any;
  handleValueDecrease: any;
  value: any;
  isClicked: any;
  item: any;
}

const ProductDetails: React.FC<ProductDetailsProps> = ({
  open,
  close,
  handleClickButton,
  handleValueIncrease,
  handleValueDecrease,
  value,
  isClicked,
  item,
}) => {
  const [zoomStyle, setZoomStyle] = React.useState({});
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleMouseMove = (e: any) => {
    const { left, top, width, height } = e.target.getBoundingClientRect();
    const x = ((e.clientX - left) / width) * 100;
    const y = ((e.clientY - top) / height) * 100;
    setZoomStyle({
      transformOrigin: `${x}% ${y}%`,
    });
  };

  const handleMouseLeave = () => {
    setZoomStyle({});
  };

  const CloseButton = () => {
    return (
      <Box sx={{ width: "100%", textAlign: "center", margin: "1rem auto" }}>
        <IconButton
          onClick={close}
          sx={{
            background: "white",
            "&:hover": {
              background: "#f2efefcf",
            },
          }}
        >
          <CloseIcon sx={{ cursor: "pointer", color: "black" }} />
        </IconButton>
      </Box>
    );
  };

  const DrawerList = (
    <Box
      sx={{
        background: "white",
        border: "1px solid rgba(18, 53, 36, 0.1)",
        boxShadow: "0 -12px 48px rgba(18, 53, 36, 0.12)",
        width: "100%",
        display: { sm: "block", md: "flex" },
        padding: "1rem",
        borderRadius: "1.25rem 1.25rem 0 0",
        margin: "auto",
      }}
      role="presentation"
    >
      <Box
        className="slider-item"
        sx={{
          position: "relative",
          overflow: "hidden",
          width: { xs: "100%", sm: "80%", md: "40%", lg: "35%" },
          height: "auto",
          margin: { xs: "1rem auto", sm: "1rem auto", md: "1rem auto" },
          borderRadius: "8px",
        }}
      >
        <Image
          width={1000}
          height={1000}
          className="slider-image"
          style={zoomStyle}
          onMouseMove={handleMouseMove}
          onMouseLeave={handleMouseLeave}
          alt="product"
          src={item?.profileImage?.secureHttpPath ?? ""}
        />
      </Box>
      <Box
        sx={{
          width: { xs: "100%", sm: "80%", md: "40%", lg: "40%" },
          margin: { xs: "1rem auto", sm: "1rem auto", md: "1rem auto" },
        }}
      >
        <Box>
          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
            {item?.title ?? ""}
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: "bold" }}>
            {item?.productQuantityDisplayName ?? ""}
          </Typography>
        </Box>
        <br />
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "left",
                alignItems: "center",
                marginBottom: "0.5rem",
              }}
            >
              <Image
                src={Coin}
                height={500}
                width={500}
                alt="coin"
                style={{
                  width: isSmallScreen ? "1.5rem" : "2rem",
                  height: isSmallScreen ? "1.5rem" : "2rem",
                }}
              />
              &nbsp;
              <Typography variant="body1" sx={{ fontWeight: "600" }}>
                {item?.salontymCoins.toLocaleString() ?? ""}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "left",
                alignItems: "center",
              }}
            >
              <Box sx={{ width: isSmallScreen ? "1.5rem" : "2rem" }}>
                <Image
                  src={Coin}
                  height={500}
                  width={500}
                  alt="coin"
                  style={{
                    width: "1.2rem",
                    height: "1.2rem",
                    margin: "auto",
                  }}
                />
              </Box>
              &nbsp;
              <Typography variant="body2" sx={{ fontWeight: "600" }}>
                {item?.cashbackSalontymCoins ?? ""} Cashback
              </Typography>
            </Box>
          </Box>

          {isClicked ? (
            <Box
              onClick={(e) => e.stopPropagation()}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-evenly",
                background:
                  "linear-gradient(135deg, rgba(223, 246, 232, 0.95) 0%, rgba(200, 239, 217, 0.85) 100%)",
                border: "1px solid rgba(31, 122, 77, 0.28)",
                borderRadius: "999px",
                color: "#123524",
                height: { xs: "35px", sm: "35px" },
                width: { xs: "125px", sm: "125px" },
              }}
            >
              <RemoveIcon
                onClick={(e) => handleValueDecrease(e, item)}
                sx={{ cursor: "pointer", fontSize: { xs: "16px", sm: "24px" } }}
              />
              <Typography
                variant="body1"
                sx={{ fontSize: { xs: "14px", sm: "16px" } }}
              >
                {value}
              </Typography>
              <AddIcon
                onClick={(e) => handleValueIncrease(e, item)}
                sx={{ cursor: "pointer", fontSize: { xs: "16px", sm: "24px" } }}
              />
            </Box>
          ) : (
            <Button
              variant="contained"
              sx={{
                boxShadow: "none",
                textTransform: "capitalize",
                minWidth: "10px",
                background:
                  "linear-gradient(135deg, rgba(223, 246, 232, 0.95) 0%, rgba(200, 239, 217, 0.85) 100%)",
                border: "1px solid rgba(31, 122, 77, 0.28)",
                borderRadius: "999px",
                height: { xs: "35px", sm: "35px" },
                width: { xs: "125px", sm: "125px" },
                color: "#123524",
                "&:hover": {
                  background:
                    "linear-gradient(135deg, rgba(200, 239, 217, 1) 0%, rgba(174, 228, 198, 0.95) 100%)",
                },
              }}
              onClick={(e) => handleClickButton(e, item)}
            >
              Add
            </Button>
          )}
        </Box>
        <Box>
          <Typography
            variant="body2"
            sx={{ fontWeight: "bold", marginTop: "1rem" }}
          >
            {item.descriptions !== null &&
            item?.descriptions.length > 0 &&
            item?.descriptions[0] != null
              ? item?.descriptions[0].title
              : ""}
          </Typography>
        </Box>
        <Box sx={{ marginTop: "1rem" }}>
          {(item?.descriptions != null &&
          item?.descriptions.length > 0 &&
          item?.descriptions[0] != null
            ? item?.descriptions[0].points
            : []
          )?.map((item: any, index: any) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                justifyContent: "left",
                alignItems: "top",
              }}
            >
              <CheckIcon sx={{ color: "#1f7a4d" }} fontSize="small" />
              &nbsp;
              <Typography variant="body2" sx={{ color: "black" }}>
                {item}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );

  return (
    <Drawer
      open={open}
      onClose={close}
      anchor="bottom"
      sx={{ zIndex: 10000 }}
      PaperProps={{
        sx: {
          background: "none",
          boxShadow: "none",
        },
      }}
    >
      <CloseButton />
      {DrawerList}
    </Drawer>
  );
};

export default ProductDetails;
